module.exports = __webpack_public_path__ + "static/img/winnipeg1.f9bb9fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/winnipeg1.jpg
// module id = 150
// module chunks = 9